import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-af3a51c0")

_pushScopeId("data-v-af3a51c0")
const _hoisted_1 = { class: "mypagemonthlyfoodsrankingdetail-page" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MypageSelectTabs = _resolveComponent("MypageSelectTabs")
  const _component_CommonDesignDialog = _resolveComponent("CommonDesignDialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_MypageSelectTabs, {
      leftTitle: _ctx.userTitle,
      rightTitle: _ctx.nationwideTitle,
      onSelectTabs: _ctx.selectTabs
    }, null, 8, ["leftTitle", "rightTitle", "onSelectTabs"]),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: !!_ctx.handleApiError,
      dialogType: _ctx.typeApiError,
      title: _ctx.getApiErrorTitle,
      message: _ctx.getApiErrorMessage,
      positiveLabel: _ctx.retryButtonTitle,
      negativeLabel: _ctx.okButtonTitle,
      onPositiveClick: _ctx.retryApiErrorHandler,
      onNegativeClick: _ctx.okApiErrorHandler
    }, null, 8, ["isShowDialog", "dialogType", "title", "message", "positiveLabel", "negativeLabel", "onPositiveClick", "onNegativeClick"])
  ]))
})